import { useFormikContext } from "formik";
import { useMemo, useState, useEffect } from "react";
import { useToastContext } from "../../../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../../../common/components/ui/loading/ButtonLoading";
import { verifyTrackerVehicle } from "../../../../../../common/services/vehicles.api";
import { FaCheckCircle } from "react-icons/fa";
import "./VelotrackActivate.scss";

type VerifyTrackerVelotrackProps = {
  onSuccessVerify: () => void;
  disabled?: boolean;
};

export default function VerifyTrackerVelotrack({ onSuccessVerify, disabled }: VerifyTrackerVelotrackProps) {
  const { notifySuccess, notifyError } = useToastContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { values } = useFormikContext<any>();
  const vehicleId = values?.vehicle?._id;

  const [isVerifying, setIsVerifying] = useState(false);
  const [status, setStatus] = useState<"pending" | "success" | "error">("pending");

  useEffect(() => {
    setStatus("pending");
  }, [vehicleId]);

  async function handleVerifyTracker() {
    try {
      setIsVerifying(true);
      const result = await verifyTrackerVehicle(vehicleId);

      if (result.ok) {
        notifySuccess("Rastreador vinculado corretamente ao veículo.");
        setStatus("success");
        onSuccessVerify();
      } else {
        notifyError(result.message || "Falha ao verificar o vínculo do rastreador.");
        setStatus("error");
      }
    } catch (err) {
      console.error(err);
      notifyError("Erro inesperado ao verificar rastreador.");
      setStatus("error");
    } finally {
      setIsVerifying(false);
    }
  }

  const badgeColor = useMemo(() => {
    if (status === "success") return "text-greenPrimary";
    if (status === "error") return "text-redPrimary";
    return "text-redPrimary";
  }, [status]);

  return (
    <div className="p-0 grid-class">
      <div>
        <h2 className="font-semibold">Clique aqui para verificar o Rastreador do veículo:</h2>
      </div>
      <div className="grid-div2">
        <ButtonWithLoader
          type="button"
          disabled={disabled || isVerifying || !vehicleId}
          isLoading={isVerifying}
          onClick={handleVerifyTracker}
        >
          Verificar Rastreador
        </ButtonWithLoader>
        <FaCheckCircle size={24} className={badgeColor} />
      </div>
    </div>
  );
}
